import React, { useState } from "react";
import "./Testimonial.css";
// import { Link } from "react-router-dom";


const Testimonials = () => {

  // const [isDisabled, setDisabled] = useState(true)
  const [isMessage, setIsMessage] = useState("");
  const [isAuthor, setIsAuthor] = useState("");
  const [isJob, setIsJob] = useState("");
  const [isImage, setIsImage] = useState("");

  const testimonials = [
    {
      message: "Digital planet is the best digital school in the whole world.",
      author: "Irabor Peace",
      job: "Web Developer",
      image:"https://i.ibb.co/CmcWL8d/poria.jpg"
    },

    {
      message: "I love Digital Planet. They offer the best courses.",
      author: "Favour Yusuf",
      job: "Content Writer & Marketer",
      image: "https://i.ibb.co/fdS63Dt/favour.jpg"
    },

    {
      message:
        "I would recommend digital planet to anyone. They never disappoint",
      author: "OreziMena Onofua",
      job: "Product Designer",
      image: "https://i.ibb.co/y6BDTNg/mena.jpg"
    },

    {
      message:
        "If you want to learn any digital skill, digital planet is your go-to school.",
      author: "Sodiq Aboola",
      job: "Social Media Expert",
      image: " https://i.ibb.co/ngg6bRD/drs.jpg"
    }
   
  ];

  const handleClickedImage = (el) => {
    setIsMessage(el.message);
    setIsAuthor(el.author);
    setIsJob(el.job);
    setIsImage(el.image);
  };

  return (
    <div className="testCont">
      <h1 className="testTitle">Testimonials</h1>

      <div className="testCard">
        <div className="feedback">
          <div className="content">

              <div id="message">{isMessage === "" ? testimonials[0].message : isMessage}</div>
         
              
        
            <div style={{ display: "flex", marginTop: "20px", marginLeft:"20px"}}>

              {testimonials.map((el, index) => (

                <>

                  <div id="client" key={index}>
                    {isAuthor === el.author ? (
                      <>
                        <div id="author">{isAuthor}</div>
                        <div id="job">{el.job}</div>
                      </>
                    ) : (
                      <div
                        style={{
                          display: isAuthor === el.author ? "none" : "block"
                        }}
                        onClick={() => handleClickedImage(el)}
                      >
                        <img src={el.image} alt="test" />
                      </div>
                    )}
                  </div>
                  <hr />
                  
                </>
              ))}
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

  

export default Testimonials;
